<template>
  <li>
    <div class="treenodecss">
      <span
        v-show="nodedatacmp.isShowRight"
        class="menu1"
        style="display: inline-block; margin-right: 5px"
      >
        <img src="../assets/右向き矢印.png" alt="" />
      </span>
      <b-form-checkbox
        v-show="nodedatacmp.hasCheckbox"
        id="flavors"
        v-model="nodedatacmp.ischecked"
        type="checkbox"
        :indeterminate="nodedatacmp.indeterminate"
        style="display: inline-block; margin-right: 5px"
        @change="
          checkboxchanged(nodedatacmp, nodedatacmp.title, nodedatacmp.ischecked)
        "
      />
      <span
        v-if="
          nodedatacmp.nodepath &&
          nodedatacmp.children &&
          nodedatacmp.children.length > 0
        "
        >{{ nodedatacmp.title }}</span
      >
      <span v-if="nodedatacmp.nodepath == null"
        ><b>{{ nodedatacmp.title }}</b></span
      >
      <b-link
        v-if="!nodedatacmp.children || nodedatacmp.children.length == 0"
        class="RatHangingFloating"
        ><b>{{ nodedatacmp.title }}</b></b-link
      >
      <span v-if="nodedatacmp.isShowNew" style="margin-left: 5px">
        <img src="../assets/NEW.png" alt="" />
      </span>
    </div>
    <ul v-if="nodedatacmp.children && nodedatacmp.children.length > 0">
      <TreeNode
        v-for="child in nodedatacmp.children"
        :key="child.title"
        :node-data="child"
        @checkedchange="checkedchange"
      />
    </ul>
  </li>
</template>

<script>
export default {
  name: 'TreeNode',
  props: {
    nodeData: Object
  },
  computed: {
    nodedatacmp: {
      get() {
        return this.nodeData
      },
      set(newValue) {
        this.$emit('change', newValue)
      }
    }
  },
  created() {
    $(function () {
      $('.treenodecss>span').off('click')
      $('.treenodecss>span').click(function () {
        $(this).parent().next('ul').slideToggle()
        $(this)
          .children('.img')
          .toggleClass('push')
          .parents('li')
          .siblings()
          .find('.img')
          .removeClass('push')
      })
    })
  },
  methods: {
    checkedchange(title, ischecked) {
      this.$emit('checkedchange', title, ischecked)
    },
    checkboxchanged(item, title, ischecked) {
      this.check()
      this.eveChild(item)
      if (item.nodepath && item.nodepath.length > 0) {
        console.log(item.nodepath)
        item.nodepath.forEach(par => {
          if (par.hasCheckbox) {
            this.eveParent(par)
          }
        })
      }
      this.$emit('checkedchange', title, ischecked)
    },
    check() {
      this.$emit('check')
    },
    eveChild(item) {
      if (item.children && item.children.length > 0) {
        if (item.ischecked === false) {
          item.children.forEach(res => {
            res.ischecked = false
            if (res.children) {
              this.eveChild(res)
            }
          })
        } else {
          item.children.forEach(res => {
            res.ischecked = true
            if (res.children) {
              this.eveChild(res)
            }
          })
        }
      }
    },
    eveParent(item) {
      if (item) {
        var cntTrue = 0
        item.indeterminate = false
        item.children.forEach(res => {
          if (res.ischecked) {
            cntTrue++
          }
          if (res.indeterminate) {
            item.indeterminate = true
          }
        })
        if (cntTrue === 0) {
          item.ischecked = false
        } else if (cntTrue === item.children.length) {
          item.ischecked = true
        } else {
          item.indeterminate = true
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
li {
  list-style: none;
  cursor: pointer;
}
.event li > ul {
  padding-left: 20px;
  display: none;
}
input[type='checkbox'] {
  margin-right: 5px;
}
.push {
  transform: rotate(90deg);
}
:hover.RatHangingFloating {
  color: RGBA(50, 102, 222, 0.7);
}
.RatHangingFloating {
  color: RGB(50, 102, 222);
}
</style>
